
import throttle from 'lodash/throttle'
import EoToolbar from '../EoToolbar/EoToolbar'

export default {
  name: 'EoHeader',
  components: { EoToolbar },
  props: {
    /**
     * Collapse bottom toolbar on scroll
     */
    collapseBottom: {
      type: Boolean,
      default: false,
    },
    /**
     * Fix the position of the header to top of the screen
     */
    fixed: {
      type: Boolean,
      default: false,
    },
    /**
     * Style: add a dropshadow
     */
    elevated: {
      type: Boolean,
      default: false,
    },
    /**
     * Style: background color of the whole header
     */
    color: {
      type: String,
      default: null,
    },
    /**
     * Moves brand left on md screens and up
     */
    moveBrandLeft: {
      type: Boolean,
      default: true,
    },
    /**
     * Style: color of the text
     */
    textColor: {
      type: String,
      default: null,
    },
    /**
     * Style: background color of the top toolbar
     */
    topColor: {
      type: String,
      default: null,
    },
    /**
     * Style: color of the text in top toolbar
     */
    topTextColor: {
      type: String,
      default: null,
    },
    /**
     * Style: background color of the bottom toolbar
     */
    bottomColor: {
      type: String,
      default: null,
    },
    /**
     * Style: color of the text in the bottom toolbar
     */
    bottomTextColor: {
      type: String,
      default: null,
    },
  },
  data () {
    return {
      height: 0,
      previousScrollY: 0,
      isBottomCollapsed: false,
      hasBottomSlot: false,
      hasTopSlot: false,
    }
  },
  computed: {
    classes () {
      return {
        'eo-header': true,
        'is-fixed': this.fixed,
        'is-elevated': this.elevated,
        'is-bottom-collapsed': this.isBottomCollapsed,
        'move-brand-left': this.moveBrandLeft,
        'has-collapsible-bottom': this.collapseBottom && this.hasBottomSlot,
        'color--transparent': this.hasBottomSlot,
        ['color--' + this.color]: !!this.color && !this.hasBottomSlot,
        ['text--' + this.textColor]: !!this.textColor,
      }
    },
  },
  watch: {
    isBottomCollapsed () {
      /**
       * Emitted when the bottom toolbar collapses or appears
       * @event input
       */
      this.$emit('collapse', this.isBottomCollapsed)
    },
  },
  updated () {
    this.checkSlotContent()
    this.onPageScroll()
  },
  created () {
    this.$parent.hasHeader = true
    this.checkSlotContent()
  },
  mounted () {
    this.previousScrollY = window.scrollY
    window.addEventListener('scroll', throttle(this.onPageScroll, 300))
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.onPageScroll)
  },
  methods: {
    async checkSlotContent () {
      this.hasTopSlot = !!this.$slots.top || !!this.$slots.topLeft || !!this.$slots.brand || !!this.$slots.topRight
      this.hasBottomSlot = !!this.$slots.bottom || !!this.$slots.bottomLeft || !!this.$slots.bottomCenter || !!this.$slots.bottomRight
    },
    async onPageScroll () {
      /**
       * Handle page scroll event
       */
      if (process.server) return
      if (!this.$refs.bottomToolbar) return
      if (!this.collapseBottom) return

      const amountScrolled = window.scrollY - this.previousScrollY
      const isScrollingDown = window.scrollY - this.previousScrollY > 0
      const isFurtherThanElement = window.scrollY > this.$refs.bottomToolbar.clientTop

      if (amountScrolled < -15 || 30 < amountScrolled) {
        // Scrolled a serious distance
        this.toggleBottomToolbar(isFurtherThanElement && isScrollingDown)
      } else if (!isFurtherThanElement) {
        // Almost no scroll distance
        this.toggleBottomToolbar(false)
      }

      this.previousScrollY = window.scrollY
    },
    toggleBottomToolbar: throttle(function (shouldCollapse) {
      this.isBottomCollapsed = shouldCollapse
    }, 300),
  },
}
